// PT-PASSWORD-FIX v1: shared password rules for register / set-new-password
export const passwordProblem = (pw) => {
    if (!pw) return "Password is required!";
    if (pw.length < 8) return "Password must be at least 8 characters";
    if (pw.length > 64) return "Password cannot exceed 64 characters";
    if (!/[A-Za-z]/.test(pw) || !/\d/.test(pw)) return "Password must contain letters and numbers";
    return "";
};
